import React from 'react';
import { isLocale, LOCALES, LOCALE_LABELS } from './types';
import { useI18n } from './I18nProvider';
import './LanguageSelector.scss';

interface LanguageSelectorProps {
  variant?: 'header' | 'auth';
}

export function LanguageSelector({ variant = 'header' }: LanguageSelectorProps) {
  const { locale, setLocale, t } = useI18n();

  return (
    <label className={`ui-language-selector ui-language-selector--${variant}`} data-component="LanguageSelector">
      <span className="ui-language-selector__sr">{t('language.label')}</span>
      <select
        aria-label={t('language.label')}
        data-testid="ui-language-selector"
        value={locale}
        onChange={(event) => {
          if (isLocale(event.target.value)) {
            setLocale(event.target.value);
          }
        }}
      >
        {LOCALES.map((code) => (
          <option key={code} value={code}>
            {LOCALE_LABELS[code]}
          </option>
        ))}
      </select>
    </label>
  );
}
